import React from 'react';
import Icon from '../../Icon';
import styled from 'styled-components';
import { text, fontFamilyBold } from '../../../styling/mixins/typography';
import { getColor } from '../../../styling/mixins/colors';

const StyledMenuItem = styled.li`
  display: flex;
  justify-content: space-between;
  ${text('small')};
  ${fontFamilyBold};
  line-height: 2.4rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  &:not(:last-child) {
    border-bottom: 1px solid ${getColor('grey', 300)};
  }

  a {
    padding: 1.6rem;
    color: ${getColor('grey', 900)};
    flex: 1;
    cursor: pointer;
  }
`;

const StyledIconWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 1.5rem;
  cursor: pointer;
`;

const StyledIcon = styled(Icon)`
  font-size: 2.4rem;
  color: ${getColor('grey', 900)};
`;

const MobileNavigationItem = ({ link, onLinkClick }) => {
  return (
    <StyledMenuItem>
      <a
        href={link.links?.length > 0 ? undefined : link.url}
        onClick={link.links?.length > 0 ? () => onLinkClick(link) : undefined}>
        {link.name}
      </a>

      {link.links?.length > 0 && (
        <StyledIconWrapper onClick={() => onLinkClick(link)}>
          <StyledIcon name="chevron-right-nav" />
        </StyledIconWrapper>
      )}
    </StyledMenuItem>
  );
};
export default MobileNavigationItem;
